import ButtonBase from "@mui/material/ButtonBase";

// PRIMENG `p-selectButton` IN THE PILLARS THEMES: JOINED, EQUAL-WIDTH SEGMENTS (WITH
// `p-fluid`), FILLED `--primary-500` UNSELECTED AND `--primary-700` SELECTED, WHITE
// TEXT, 0.5REM 0.75REM PADDING; ONLY THE OUTER CORNERS ARE ROUNDED. WITHOUT `p-fluid`
// (`fluid={false}`) THE SEGMENTS ARE CONTENT-SIZED AND THE GROUP IS AS WIDE AS THEY ARE.
export function PSelectButton<V extends string>(props: {
  options: Array<{ label: string; value: V; disabled?: boolean }>;
  value: V;
  onChange: (v: V) => void;
  className?: string;
  ariaLabel?: string;
  fluid?: boolean;
}) {
  const { options, value, onChange, className = "", ariaLabel, fluid = true } = props;
  return (
    <div className={`p-inputgroup ${fluid ? "flex w-full" : "inline-flex"} ${className}`} role="radiogroup" aria-label={ariaLabel}>
      {options.map((o) => {
        const selected = o.value === value;
        return (
          <ButtonBase
            key={o.value}
            role="radio"
            aria-checked={selected}
            disabled={o.disabled}
            disableRipple
            onClick={() => onChange(o.value)}
            sx={{
              flex: fluid ? "1 1 0" : "0 0 auto",
              padding: "0.5rem 0.75rem",
              fontFamily: "inherit",
              fontSize: "inherit",
              lineHeight: "normal",
              color: "#ffffff",
              backgroundColor: selected ? "var(--primary-700)" : "var(--primary-500)",
              transition: "background-color 0.15s",
              "&:hover": { backgroundColor: selected ? "var(--primary-700)" : "var(--primary-600)" },
              "&.Mui-disabled": { opacity: 0.65 },
            }}
          >
            {o.label}
          </ButtonBase>
        );
      })}
    </div>
  );
}
